import styled from 'styled-components';
import Carousel from 'nuka-carousel';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';

export const ImgWrapper = styled.div`
  max-width: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
`;

export const controlStyles = {
  nextButtonStyle: {
    opacity: 0,
    width: '8vw',
    height: '430px',
  },
  prevButtonStyle: {
    opacity: 0,
    width: '8vw',
    height: '430px',
  },
  pagingDotsStyle: {
    fill: 'transparent',
    height: '8px',
    width: '8px',
    border: '1px solid #176F69',
    borderRadius: '50%',
    opacity: 1,
  },
  pagingDotsClassName: 'dots',
  pagingDotsContainerClassName: 'wedding-websites-dots-vertical-carousel-container',
};

export const StyledCarousel = styled(Carousel)<{ shiftPosition?: number; hoverSlide: number; selectedSlide: number }>`
  ${themeMediaQuery('below_sm')} {
    margin-top: -${themeSpace(11)};
  }
  .wedding-websites-dots-vertical-carousel-container {
    display: flex !important;
    position: relative !important;
    width: 72px;
    justify-content: space-evenly;
  }

  .slider-control-bottomcenter {
    position: absolute !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    bottom: 100% !important;
  }

  .paging-item.active > button {
    background: #176f69 !important;
  }

  ul > li:nth-child(${props => props.hoverSlide}) {
    transform: ${props => `translateX(${props.shiftPosition}px)`} !important;
    z-index: 1;
  }

  ul > li:nth-child(${props => props.selectedSlide}) {
    transform: scale(1.1) !important;
    transition: transform 0.6s ease-in-out !important;
    ${themeMediaQuery('below_sm')} {
      transform: scale(1.8) !important;
    }
  }
`;

export const CarouselIndicatorWrap = styled.div`
  position: absolute;
  //bottom: 70px;
  z-index: 999;
  width: 100%;
  ul {
    display: flex;
    justify-content: center;
    div + div {
      margin-left: 16px;
    }
  }
  ${themeMediaQuery('below_sm')} {
    position: relative;
    bottom: 40px;
  }
`;

export const MainTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 400px;
    ${themeMediaQuery('xl')} {
      max-width: 490px;
    }
  }
`;

export const AnswerWrapperBox = styled(Box)`
  background: linear-gradient(360deg, #fffcf7 0%, #ebffe8 100%);
  position: relative;
`;
